var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartLineUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.575 29.388a1.344 1.344 0 00-.95-2.294H5.719v-2.475l7.406-7.407 3.424 3.426s0 0 0 0a1.342 1.342 0 001.902 0s0 0 0 0L26 13.088v2.225a1.344 1.344 0 002.688 0v-5.47A1.344 1.344 0 0027.343 8.5h-5.469a1.344 1.344 0 100 2.688H24.1l-6.6 6.6-3.424-3.426s0 0 0 0a1.342 1.342 0 00-1.902 0s0 0 0 0L5.72 20.819V6.563a1.344 1.344 0 10-2.688 0v21.875a1.344 1.344 0 001.344 1.343h26.25c.356 0 .698-.141.95-.393z",
    fill: "#000AFF",
    stroke: "#000AFF",
    strokeWidth: 0.5
  })));
}
export default SvgChartLineUp;